import React from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { BsCheck2All } from 'react-icons/bs'
import './confirmation.css'

const Completion = ({closeoverlay}) => {
  const handleClose = () =>{
    closeoverlay()
  }

  return (
    <div className='overlay-container'>
      <div className='overlay-completed-container'>
        <div className='top-container-completed-notif'>
            <AiOutlineCloseCircle id='close-Iccon' onClick={handleClose}/>
        </div>

        <div className='completed-check-container'>
          <BsCheck2All id='completed-check'/>
        </div>

        <span className='comletedTasks-id'>Completed!</span>
      </div>
    </div>
  )
}

export default Completion